import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums';

const UpsertBlockedStore = (params: any) =>
    request({
        url: ApiURL.Command.UpsertBlockedStore,
        method: RequestType.POST,
        data: params,
    });

const DeleteBlockedStore = (params: any) =>
    request({
        url: ApiURL.Command.DeleteBlockedStore,
        method: RequestType.POST,
        data: params,
    });

const StoreCargoBlockingCommand = {
    UpsertBlockedStore,
    DeleteBlockedStore,
};

export default StoreCargoBlockingCommand;
